import isMobile from "../common/is-mobile.js";

if ($(".js-chat-pageHeader").length) {
  class FixedPageHeader {
    constructor() {
      this.body = document.querySelector("body");
      this.scrollPosition = "";
      this.scrollHeader = document.querySelector(".js-chat-pageHeader");
      this.scrollTaget = document.querySelector(".l-chat-main__body");
    }

    init() {
      //チャット画面初期表示を最新チャット内容までスクロール
      this.scrollTaget.scroll(0, this.scrollTaget.scrollHeight);

      if (isMobile(1024)) {
        //固定用CSS
        const styles = {
          position: "fixed",
          top: "0",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        };

        Object.assign(this.body.style, styles);
      }

      //スクロールイベント付与
      this.scrollEvent();
    }

    scrollEvent() {
      //初期位置定義
      let start = 0,
        targetScroll = 0;
      this.scrollTaget.addEventListener("scroll", () => {
        //要素のスクロール量を取得・設定
        targetScroll = this.scrollTaget.scrollTop;
        if (isMobile(1024)) {
          if (targetScroll >= start) {
            this.scrollHeader.classList.remove("is-show");
          } else {
            this.scrollHeader.classList.add("is-show");
          }
          //スクロールの毎に更新
          start = targetScroll;
        }
      });
    }
  }

  const fixedPageHeader = new FixedPageHeader();
  fixedPageHeader.init();
}
